import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VimeoEmbed from '../VimeoEmbed/VimeoEmbed';
import WistiaEmbed from '../WistiaEmbed/WistiaEmbed';
import YoutubeEmbed from '../YoutubeEmbed/YoutubeEmbed';
import './index.scss';

export default function VideoPlayer(props) {
  const {
    title,
    videoSource,
    videoId,
    aspectRatio = [],
    autoplay = true,
    controls = true,
  } = props;

  const [width, height] = aspectRatio;
  const aspectRatioClassNames = classNames({
    [`embed-responsive embed-responsive-${width}by${height}`]:
      aspectRatio.length,
  });

  return (
    <div
      className={`c-video-player c-video-player--${videoSource.toLowerCase()}`}
    >
      <div className={aspectRatioClassNames}>
        {videoSource === 'VIMEO' && (
          <VimeoEmbed
            title={title}
            videoId={videoId}
            autoplay={autoplay}
            controls={controls}
          />
        )}
        {videoSource === 'WISTIA' && (
          <WistiaEmbed videoId={videoId} muted={false} playerColor="000000" />
        )}
        {videoSource === 'YOUTUBE' && (
          <YoutubeEmbed
            title={title}
            videoId={videoId}
            autoplay={autoplay}
            controls={controls}
          />
        )}
      </div>
    </div>
  );
}

VideoPlayer.propTypes = {
  videoSource: PropTypes.oneOf(['VIMEO', 'WISTIA', 'YOUTUBE']).isRequired,
  videoId: PropTypes.string.isRequired,
  aspectRatio: PropTypes.arrayOf(PropTypes.number),
  autoplay: PropTypes.bool,
  controls: PropTypes.bool,
  title: PropTypes.string,
};
